import { BrowseActionTypes, IToggleFilterCategory } from "../models/browseActions";
import { TOGGLE_FILTER_CATEGORY } from "../types";

export default (category: IToggleFilterCategory["payload"]): BrowseActionTypes => ({
    type: TOGGLE_FILTER_CATEGORY,
    payload: category,
});
